// import PropTypes from "prop-types";
// import React from 'react';
// import {Helmet} from "react-helmet";

// const SEO = ({title}) => {
//     return (
//         <Helmet>
//             <meta charSet="utf-8" />
//             <title>{title}</title>
//             <meta name="robots" content="noindex, follow" />
//             <meta name="description" content="Exomac – Corporate Business React JS Template" />
//             <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
//         </Helmet>
//     )
// }

// SEO.propTypes = {
//     title: PropTypes.string
// };

// export default SEO;

import PropTypes from "prop-types";
import React from "react";
import { Helmet } from "react-helmet";

const SEO = ({ title, description, robots }) => {
  return (
    <Helmet>
      <meta charSet="utf-8" />
      <title>{title}</title>
      <meta
        name="robots"
        content={robots || "index, follow"}
      />
      <meta
        name="description"
        content={description || "Official website of Tawanai (TWA Energy). Explore our energy technology, whitepapers, and sustainable solutions."}
      />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, shrink-to-fit=no"
      />
    </Helmet>
  );
};

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  robots: PropTypes.string,
};

export default SEO;